import {Constants} from '../../constants';
import {useDimensions} from './useDimensions';

export const useCardScaleFactor = () => {
  const windowWidth = useDimensions().window.width;
  return (
    (windowWidth - Constants.CARD_HORIZONTAL_MARGIN * 2) / Constants.CARD_WIDTH
  );
};
